import styled from '@emotion/styled';
import Image from 'next/image';
import { Trustpilot } from '../TrustSeals';

type SealsOrientation = 'column' | 'row';

const Seals = styled('div', {
  shouldForwardProp: prop => prop !== 'orientation',
})<{ orientation: SealsOrientation }>`
  display: flex;
  flex-direction: ${({ orientation }) => orientation};
  align-items: ${({ orientation }) =>
    orientation === 'column' ? 'flex-end' : 'center'};
  justify-content: center;
  gap: ${({ orientation, theme }) =>
    orientation === 'column' ? theme.spacing[40] : theme.spacing[30]};
`;

/* The compact card of the design: logo above the stars, no rating label. */
const TrustpilotCard = styled(Trustpilot)`
  width: 9.75rem;
  border-radius: ${({ theme }) => theme.radius.sm};
  box-shadow: ${({ theme }) => theme.elevation.medium};

  & > button {
    gap: ${({ theme }) => theme.spacing[10]};
    padding: 0 ${({ theme }) => theme.spacing[20]}
      ${({ theme }) => theme.spacing[20]};
  }
`;

/*
 * The Deutschland Test seal. On the stage (column) it is as wide as the
 * Trustpilot card (156px, as in the design). Below the search mask (row) it
 * is as high as the Trustpilot card (96px). The shadow is the same as on the
 * Trustpilot card.
 */
const DeutschlandTestSeal = styled(Image, {
  shouldForwardProp: prop => prop !== '$orientation',
})<{ $orientation: SealsOrientation }>`
  display: block;
  width: ${({ $orientation }) =>
    $orientation === 'column' ? '9.75rem' : 'auto'};
  height: ${({ $orientation }) => ($orientation === 'column' ? 'auto' : '6rem')};
  border-radius: ${({ theme }) => theme.radius.md};
  box-shadow: ${({ theme }) => theme.elevation.medium};
`;

export { DeutschlandTestSeal, Seals, TrustpilotCard };
export type { SealsOrientation };
